import React, { useState, useMemo, FC } from "react";
import { Link } from "react-router-dom";

import { Col, FormGroup, Row } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import { MODAL_TYPES, Permissions } from "../../shared/models/Types";

import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import {
  BuySell,
  BuySellListResponse,
  contentTypeFormatter,
  filtersTypes,
  paymentFormatter,
} from "./BuySell.constants";
import { formatDateString } from "../../shared/utils/formatText";
import DeviceBuySellDeviceDeleteModal from "./DeviceBuySellDeviceDeleteModal";
import BuySellDevicePartDetailModal from "./DevicePartBuySellDetailModal";
import SelectBox from "../../shared/base-components/SelectBox";
import { useForm } from "react-hook-form";

export interface BuySellDevicePartListProps {
  buySellDevicePartListData: any;
  setSelectedFilter: React.Dispatch<any>;
  isBuySellDevicePartListLoading?: boolean;
  buySellDevicePartListMutation: UseMutateFunction<
    BuySellListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

const BuySellDevicePartList: FC<BuySellDevicePartListProps> = ({
  buySellDevicePartListData,
  buySellDevicePartListMutation,
  isBuySellDevicePartListLoading,
  setSelectedFilter,
}) => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const permissionList = useRecoilValue(permissionsSelector);

  const { control } = useForm();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalOptions, setModalOptions] = useState<{
    data?: BuySell;
    modalType?: string;
  }>({
    data: undefined,
    modalType: undefined,
  });

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalOptionsHandler = (data?: any, modalType?: string) => {
    setModalOptions({ data: data, modalType: modalType });
  };

  const viewPermission = permissionList[Permissions.ViewDevice];
  const deletePermission = permissionList[Permissions.DeleteDevice];

  const columns = useMemo(
    () => [
      {
        Header: "Malzeme alış/satış Adı",
        filterable: true,
        disableFilters: true,
        accessor: "device_part.name",
        Cell: (response: any) => (
          <>
            <p className="text mb-0">
              {response.row.original?.device_part?.name}
            </p>
          </>
        ),
      },
      {
        Header: "Miktar",
        filterable: false,
        disableFilters: true,
        accessor: "amount",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.amount}
            </h5>
          </>
        ),
      },
      // {
      //   Header: "Toplam Fiyat",
      //   filterable: false,
      //   disableFilters: true,
      //   accessor: "total_price",
      //   Cell: (response: any) => (
      //     <>
      //       <h5 className="font-size-14 mb-1">
      //         {response.row.original?.total_price}
      //       </h5>
      //     </>
      //   ),
      // },
      {
        Header: "İşlem",
        filterable: false,
        disableFilters: true,
        accessor: "content_type",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {contentTypeFormatter(response.row.original?.content_type)}
            </h5>
          </>
        ),
      },
      {
        Header: "Tarih",
        filterable: false,
        disableFilters: true,
        accessor: "date",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {formatDateString(response.row.original?.date)}
            </h5>
          </>
        ),
      },
      {
        Header: "Not",
        filterable: false,
        disableFilters: true,
        accessor: "note",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">{response.row.original?.note}</h5>
          </>
        ),
      },
      {
        Header: "Ödeme Tipi",
        filterable: false,
        disableFilters: true,
        accessor: "payment_type",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {paymentFormatter(response.row.original?.payment_type)}
            </h5>
          </>
        ),
      },
      {
        Header: "Tedarikçi",
        filterable: false,
        disableFilters: true,
        accessor: "supplier",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.supplier}
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const deviceData = cellProps.row.original.id;

                      toggle();
                      modalOptionsHandler(deviceData, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const mobileColumns = useMemo(
    () => [
      {
        Header: "Cihaz Adı",
        filterable: false,
        disableFilters: true,
        accessor: "name",
        Cell: (response: any) => (
          <>
            <p className="text mb-0">
              {response.row.original?.device_part?.name}
            </p>
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const deviceDat = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(deviceDat, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}

              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-eye font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DETAIL);
                  }}
                ></i>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">Malzeme alış/satış Listesi</h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>

      <Row className="align-items-center">
        <div className={"mt-4 pt-2 text-muted"}>
          <FormGroup className="mb-3">
            <Col sm="12" md="4" lg="4">
              <SelectBox
                control={control}
                name="devicePart"
                className="form-control"
                onChangeHandler={(e) =>
                  setSelectedFilter(parseInt(e.target.value))
                }
                options={filtersTypes}
              />
            </Col>
          </FormGroup>
        </div>
      </Row>

      <Row>
        <Col lg="12">
          {buySellDevicePartListData?.length && viewPermission ? (
            <DataTable
              columns={isMobile ? mobileColumns : columns}
              data={buySellDevicePartListData}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          ) : (
            !isBuySellDevicePartListLoading && (
              <>Herhangi bir malzeme alış/satış bulunmamaktadır.</>
            )
          )}
        </Col>
      </Row>

      {isModalOpen &&
        deletePermission &&
        modalOptions.modalType === MODAL_TYPES.DELETE && (
          <DeviceBuySellDeviceDeleteModal
            deviceData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
            buySellDevicePartListMutation={buySellDevicePartListMutation}
          />
        )}

      {isModalOpen && modalOptions.modalType === MODAL_TYPES.DETAIL && (
        <BuySellDevicePartDetailModal
          deviceData={modalOptions.data}
          modalType={modalOptions.modalType}
          isModalOpen={isModalOpen}
          toggle={toggle}
        />
      )}
    </React.Fragment>
  );
};

export default BuySellDevicePartList;
